// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { documentsStyles } from "@sc/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import { styledScrollbar, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

documentsStyles.documentsWrapper = {
    container: {
        css: css`
            margin-bottom: 24px;
            display: flex;
            flex-direction: column;
            row-gap: 12px;
            padding: 12px 5px 12px 12px;
            ${xScreen("lte", "md")} {
                margin-bottom: 0;
                height: calc(100% - 24px);
                margin-top: 24px;
            }
            @media print {
                display: none;
            }
        `,
    },
};

documentsStyles.linksWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        max-height: 256px;
        ${styledScrollbar(4, 0)};
    `,
};

documentsStyles.title = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        margin: 0;
    `,
};

documentsStyles.documentWrapper = {
    css: css`
        padding-right: 7px;
    `,
};

documentsStyles.documentLink = {
    typographyProps: {
        css: css`
            display: flex;
        `,
    },
};

documentsStyles.documentNameText = {
    size: 16,
    lineHeight: "17px",
    weight: "bold",
};

documentsStyles.documentIcon = {
    color: "text.link",
    size: 16,
    css: css`
        margin-right: 8px;
        opacity: 0.66;
        &,
        svg {
            width: 12px;
        }
    `,
};
